export const GetFormattedRewardCatalog = (apiResponse = {}) => {
  const {
    data,
    totalRecords = '',
    totalPages = '',
    pageSize = '',
    currentPage = '',
    activeCount = ''
  } = apiResponse;

  const formattedRewardCatalog = data?.map(GetRewardCatalogItem);

  return {
    data: formattedRewardCatalog,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    activeCount
  };
};

// Helper function to map individual items
const GetRewardCatalogItem = (item = {}) => {
  const {
    id = null,
    name = '',
    type = '',
    rewardId = '',
    inventory = `${item.availableInventory}/${item.totalInventory}`,
    rewardAcceptance = '',
    reportUrl = null,
    startDate,
    endDate,
    updatedDate,
    updatedBy = '',
    status = '',
    uuid = ''
  } = item;

  return {
    id,
    name,
    type,
    rewardId,
    inventory,
    rewardAcceptance,
    reportUrl,
    startDate: startDate,
    endDate: endDate,
    updatedDate: updatedDate,
    updatedBy,
    status,
    uuid
  };
};
